import React, { Component } from 'react';
import {c_markers as colors} from '../a-Graphic/Colors';
import {p_size_1, p_size_2, p_size_3, p_size_4} from '../a-Graphic/Layout';

import getMyMap, {createNamesLayer, createResidentialAreasMassLayer, createCommuneBordersLayer, createResidentialAreasWhiteZoneLayer,
   createCommuneMassLayer, getLegend, createPlacesLayer, createGriddedLayer, createCommunesNamesLayerEasy} from '../b-LeafletMap/leaflet_map';

import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';
import LegendPlace from '../b-LeafletMap/Legend/LegendPlace';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';
import LegendWhiteZone from '../b-LeafletMap/Legend/LegendWhiteZone';

var white_zone_limit_1 = 1.5;
var white_zone_limit_2 = 5;

class General extends React.Component {

  componentDidMount() {
    /* EDUCATION AREAS */
    var places = this.props.territory.places;
    //var distances = this.props.territory.distance_matrix;

    var activity_cluster = this.props.territory.activity_cluster

    var cluster_0 = activity_cluster.filter((p) => p.level==0)
    var cluster_0_coords = cluster_0.map((a) => a.coords)
    var cluster_0_labels = cluster_0.map((a) => a.name)
    var cluster_1 = activity_cluster.filter((p) => p.level==1)
    var cluster_1_coords = cluster_1.map((a) => a.coords)
    var cluster_1_labels = cluster_1.map((a) => a.name)
    var cluster_2 = activity_cluster.filter((p) => p.level==2)
    var cluster_2_coords = cluster_2.map((a) => a.coords)
    var cluster_2_labels = cluster_2.map((a) => a.name)

    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    /* GRIDDED POPULATION */
    var gridded_population = [].concat(...this.props.territory.communes.map((c)=>c.gridded_population));
    var pop_coords = gridded_population.map((c) => c.coords);
    var pop_masses = gridded_population.map((c) => parseInt(c.population));
    var pop_labels = gridded_population.map((c) => c.population + " - hab");

  /* RESIDENTIAL */
    var residential_areas = [];
    this.props.territory.communes.map((c) => residential_areas = residential_areas.concat(c.residential_areas));
    var ra_population = residential_areas.map((ra) => ra.population)
    var ra_labels = residential_areas.map((ra)=> ra.name + " - " + ra.population + " hab")

    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    var communes_layer = createCommuneBordersLayer(mymap, communes)
    //createResidentialAreasWhiteZoneLayer(mymap, residential_areas, cluster_0_coords.concat(cluster_1_coords).concat(cluster_2_coords), distances, white_zone_limit_1, white_zone_limit_2);
    //createResidentialAreasMassLayer(mymap, residential_areas, ra_population, ra_labels);
    createGriddedLayer(mymap, pop_coords, pop_masses, pop_labels);
    createPlacesLayer(mymap, cluster_2_coords, p_size_3/2, colors[2], cluster_2_labels);
    createPlacesLayer(mymap, cluster_1_coords, p_size_2/2, colors[1], cluster_1_labels);
    createPlacesLayer(mymap, cluster_0_coords, p_size_1/2, colors[0], cluster_0_labels);
    createCommunesNamesLayerEasy(mymap, communes)
    //createNamesLayer(mymap, communes_coords, communes_names);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }


  render() {
    var gridded_population = [].concat(...this.props.territory.communes.map((c)=>c.gridded_population));
    var pop_masses = gridded_population.map((c) => parseInt(c.population));

    var [colors_legend, intervals] = getLegend(pop_masses);
    return(

          <div className="row">
            <div className="col-10">
              <div style={{height: "500px"}} id={this.props.id}></div>
            </div>
            <div className="col-2 pr-0 pl-0">
                <p><b>Population du carreau</b></p>
                <p><i>(carreau de 200m)</i></p>
                 <LegendValues intervals={intervals} colors={colors_legend}/>
                 <div className="mt-4 mb-4"></div>
                 {/*<LegendWhiteZone label="(distance du village ou quartier au pôle le plus proche)" limit1={white_zone_limit_1} limit2={white_zone_limit_2}/>*/}


                 <div className="mt-3"></div>
                 <LegendPlace color={colors[0]} size={p_size_1+2} label="Pôles de proximité" subtitle="école, médecin, commerce alimentaire"/>
                 <LegendPlace color={colors[1]} size={p_size_2+2} label="Pôles intermédiaires" subtitle="restauration, infrastructures sportives ou culturelles, commerces et services"/>
                 <LegendPlace color={colors[2]} size={p_size_3+2} label="Pôles complets" subtitle="tous commerces et services"/>
            </div>
          </div>
    )
  }
}

export default General;
